import module from '@app/sesion/module'

module.config(($stateProvider) => {
  $stateProvider.state('sesion', {
    url: '',
    template: '<ui-view></ui-view>',
    abstract: true,
  })
})



// WEBPACK FOOTER //
// ./src/app/sesion/routes/sesion.js